import React, { useEffect, useState } from 'react';
import { ActionButton } from '../../ActionButton';
import { styles } from './BundleOffering.css';
import { formatMoney } from '@jbhi-fi/lanyard-ui/global/utils';
import { CartActionState } from '../../CartProvider/types';
import { submitTracking } from '../../Tracking/utils/shopifyActionTrackingHelper';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { ProductGtmData } from '@jbhi-fi/apis/src/algolia/types/ProductGtmData';
import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';
import { trackAddToCart } from '@jbhi-fi/utils/src/ga4Tracking';
import { trackViewItemList } from '@jbhi-fi/utils/src/ga4Tracking/functions/trackViewItemList';

export interface BundleOfferingProps {
  title: string;
  imageUrl: string;
  itemUrl: string;
  price: number;
  itemListName?: string;
  tagManagerData?: ProductGtmData;
  transformedGtmData?: EcommerceCartItem;
  location?: string;
  onAdd?: () => Promise<void> | void;
}

export const BundleOffering = ({
  title,
  imageUrl,
  itemUrl,
  price,
  itemListName,
  tagManagerData,
  transformedGtmData,
  location,
  onAdd,
}: BundleOfferingProps) => {
  const [state, setState] = useState<CartActionState>(CartActionState.Default);

  const trackGtmButtonImpression = () => {
    submitTracking({
      event: 'productImpression',
      trackingDescriptor: {
        page: 'cart',
        group: 'shopifyBundle',
        category: 'getItAllTogether',
        currency: getStoreCurrency(),
        ecommerceExtraProps: {
          ...tagManagerData,
          list: itemListName,
        },
      },
      gtm: {},
    });
    trackViewItemList({
      currency: getStoreCurrency(),
      listName: itemListName,
      viewedItems: transformedGtmData ? [transformedGtmData] : [],
    });
  };
  useEffect(() => {
    trackGtmButtonImpression();
  }, [title]);

  const handleAdd = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!onAdd || state === CartActionState.Updating) return;
    setState(CartActionState.Updating);
    const addedItems = {
      ...transformedGtmData,
      marketplace_product: 'N',
      marketplace_seller_type: 'N/A',
      marketplace_seller_name: 'N/A',
    } as EcommerceCartItem;
    try {
      trackAddToCart({
        location: location || '',
        currency: getStoreCurrency(),
        addedItems,
        message: 'Bundle buy',
      });
      await onAdd();
    } catch (error) {
      console.error(error);
    }
    setState(CartActionState.Default);
  };

  return (
    <div className={styles.container}>
      <a className={styles.topSection} href={itemUrl}>
        <div className={styles.imageAndTitle}>
          <img src={imageUrl} alt={title} className={styles.image} />
          <div className={styles.titleAndButton}>
            <span>{title}</span>
            <div className={styles.buttonContainer}>
              <ActionButton
                label="Add to cart"
                actionFinishedLabel="Added"
                state={state}
                onClick={handleAdd}
                size="sm"
              />
            </div>
          </div>
        </div>
        <span>{formatMoney(price)}</span>
      </a>
    </div>
  );
};
